'use client';

import { useParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { getHash } from '@/_utils/url';

export const useHash = () => {
  const [isClient, setIsClient] = useState<boolean>(false);
  const [hash, setHash] = useState<string | undefined>(getHash());
  const params = useParams();

  useEffect(() => {
    setIsClient(true);
    setHash(getHash());
  }, [params]);

  return isClient ? hash : undefined;
};
